import { fromJS, Map } from 'immutable';

export function request(state, { id, status }) {
    let parking = state.get('parking') || Map();

    parking = parking.set(id, Map({
        state: 'IN_PROGRESS',
        status
    }));

    return state.set('parking', parking);
}

export function error(state, { id, errors }) {
    let parking = state.get('parking') || Map();

    parking = parking.set(id, Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state.set('parking', parking);
}

export function finish(state, { id, data }) {
    let parking = state.get('parking') || Map();

    parking = parking.set(id, Map({
        state: 'FINISHED'
    }));

    let items = state.get('items') || Map();
    items = items.set(id, fromJS(data));

    return state
        .set('items', items)
        .set('parking', parking);
}
